/*
 * @author HOPS
 * @copyright Heritage Operations Processing Limited
 */

import styles from "./EditFormTableList.module.scss";
import {TableList} from "./TableList";

/**
 * An abstraction of the TableList component used as the base table in EditForm
 * 
 * @param {Boolean} loading 
 * @param {Boolean} error 
 * @param {Object[]} data 
 * @param {String} labelsWidth 
 * @param {Boolean} hideEmpty return null if filtered data is empty
 * @param {String} emptyMessage 
 * @param {String} className 
 */
export const EditFormTableList = ({
	loading,
	error,
	data,
	labelsWidth,
	hideEmpty,
	emptyMessage,
	className
}) => {
	const classes = [styles.editFormTableList];

	if (className) {
		classes.push(className);
	}

	return (
		<TableList
			loading={loading}
			error={error}
			data={data}
			labelsWidth={labelsWidth}
			hideEmpty={hideEmpty}
			emptyMessage={emptyMessage}
			className={classes.join(" ")}
			variant={null} />
	);
};
